import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Account } from '@app/core/models/common.models';
import { ItemLabelComponent } from '@app/shared/components/campaign-adgroup-label/item-label.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'adspt-account-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, AsyncPipe, TranslateModule, SharedDirectivesModule, NgTemplateOutlet],
})
export class AccountLabelComponent extends ItemLabelComponent<Pick<Account, 'accountName' | 'accountId'>> {
  @Input()
  labelProperty = 'accountName' as const;

  readonly type = 'common.account';

  override get label(): string {
    return `${super.label} | ${this.item?.accountId}`;
  }
}
